<template>
    <div class="supplier-edit pt-4">

      <div >

        <h3>工程</h3>

        <v-container>
          <v-row>
            <v-col cols="6" v-for="pg in list" :key="pg.processGroupCd">

              <v-card>
                <v-card-title>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="mb-1">
                        {{pg.processGroupName}}
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <a v-on:click.prevent="onEditClick(pg)"><v-icon>mdi-pencil-box</v-icon></a>
                    </v-list-item-action>
                  </v-list-item>
                </v-card-title>
                <v-card-text>

                  <v-container class="my-0 py-0">
                    <v-row>
                      <v-col cols="6" class="my-0 py-0">
                        <div v-for="process in pg.processes" :key="process.processCd">                          
                          {{process.processCd}}{{process.processName}}
                        </div>
                      </v-col>
                      <v-col cols="6" class="my-0 py-0">
                        <div v-for="ss in pg.sizeSet" :key="ss.itemCd" class="mx-1">
                          <span>{{ss.name}}</span>
                          <span v-if="ss.useRange">{{ss.value1}}〜{{ss.value2}}</span>
                          <span v-else>{{ss.value1}}</span>
                          <span>{{ss.unit}}</span>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-chip-group column v-if="pg" >
                          <v-chip v-for="mat in pg.materials" :key="mat.materialCd" outlined small color="indigo"> {{mat.materialName}} </v-chip>
                          <v-chip v-for="mats in pg.materialFaces" :key="mats.materialFaceCd" outlined small color="orange" > {{mats.materialFaceName}} </v-chip>
                          <v-chip v-for="tag in pg.tags" :key="tag" outlined small color="grey" > {{tag}} </v-chip>
                        </v-chip-group>
                      </v-col>
                    </v-row>
                  </v-container>

                </v-card-text>
              </v-card>

            </v-col>
          </v-row>

        </v-container>

        <v-divider class="mt-3 mb-3"/>
      </div>

      <v-btn @click="onNewClick">追加</v-btn>

        <!-- 工程登録ダイアログ-->
        <SupplierProcessDialog ref="processEditDialog"></SupplierProcessDialog>

    </div>
</template>
<script>
import BaseView from "../../components/BaseView";
import SupplierProcessDialog from "./SupplierProcessDialog";

export default {
    mixins:[BaseView],
    components: {
        SupplierProcessDialog
    },
    props:{
      process_groups: {
        type: Array,
        required: true
      },
    },
  computed: {
    processGroupMap: function () {
      return this.$store.state.processings.groupMap;
    },
  },
    data: () => ({
        isInitialized:false,
        isFetched:false,
        isLoading:false,
        isDownloading:false,

        // 編集中データ
        editData: {
          processGroupCd: "",
          processGroupName: "",
          processes:[
            {
              processCd:"",
              processGroupCd:"",
              processName:"",
            }
          ],
          tags: [],
          materials: [
            {
              id: 0,
              materialCd: "",
              materialName: ""
            }
          ],
          materialFaces: [
            {
              materialFaceCd: "",
              materialFaceName: ""
            }
          ],
          availableSizes: [
            {
              itemCd: "",
              name: "",
              unit: "",
              useRange: false,
              value1: null,
              value2: null,
            }
          ],
        },

        list:[
          {
            processGroupCd: "",
            processGroupName: "",
            processes:[
              {
                processCd:"",
                processGroupCd:"",
                processName:"",
              }
            ],
            tags: [ ],
            materials: [
              {
                id: 0,
                materialCd: "",
                materialName: ""
              }
            ],
            materialFaces: [
              {
                materialFaceCd: "",
                materialFaceName: ""
              }
            ],
            sizeSet: [
              {
                itemCd: "",
                name: "",
                unit: "",
                useRange: false,
                value1: null,
                value2: null,
              }
            ],
          }
        ],

        condition:{},
        pager:{},
        errors:{},
        valid:true,
    }),

    mounted:function() {
        this.setupConditions();
        this.refreshData();
    },
    created:function() {
    },
    watch: {
      '$route':function (to, from) {
          this.setupConditions();
      },
      'process_groups':function (to, from) {
          this.refreshData();
      },
    },
    methods: {
        setupConditions(){

        },

        fetchData(needDataFetch){
            let self = this;
            if (!this.isInitialized){
                this.fetchBasicData(function () {
                    self.fetchData(needDataFetch)
                });
                return;
            }
            if (needDataFetch){
                this.isLoading = true;
                Promise.resolve()
                    .then(data => {
                        //
                    })
                    .catch(function(err) {
                        console.log(err);
                        self.showErrorToast("データの取得に失敗しました。");
                    });
            }
        },

        fetchBasicData(finishProc){
            this.isInitialized = true;
            if (finishProc){
                finishProc();
            }
        },

        async onEditClick(groupRec){

            let dialogRef = this.$refs.processEditDialog;

            let groupId = groupRec.processGroupCd;
            let idx = this.list.findIndex(a => a.processGroupCd == groupId)

            console.log("onEditClick processGroupCd=" + groupId + " idx="+ idx)

            this.editData = groupRec;

            let dialogResult = await dialogRef.open(this.sup_cd,"",this.editData,{});
            if (dialogResult != null){
              if (dialogResult[0] === 1){
                let newData = dialogResult[1]
                this.$emit("cng-process", idx,newData)
              }
              console.log(dialogResult)
            }
        },

      async onNewClick(){
        let dialogRef = this.$refs.processEditDialog;
        let dialogResult = await dialogRef.open(this.sup_cd,"",this.makeNewEditData(),{});
        if (dialogResult != null){
          if (dialogResult[0] === 1){
            let newData = dialogResult[1]
            this.$emit("cng-process", -1,newData)
          }
          console.log(dialogResult)
        }
      },

      makeNewEditData(){
        return {
          processGroupCd: "",
          processGroupName: "",
          processes:[],
          tags: [],
          materials: [],
          materialFaces: [],
          availableSizes: [],
        }
      },

      refreshData(){

        this.list.splice(0)

        this.process_groups.forEach(pg =>{
          this.list.push(pg)
        })

      },

      dialogSave(){

      },


    },

}
</script>